var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMealLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9951 39.0098C32.2794 39.0098 38.9951 32.294 38.9951 24.0098C38.9951 15.7255 32.2794 9.00977 23.9951 9.00977C15.7108 9.00977 8.99512 15.7255 8.99512 24.0098C8.99512 32.294 15.7108 39.0098 23.9951 39.0098Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7855 23.3896V32.7296",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1055 15.6797V32.7297",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9755 15.6797V32.7297",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1755 20.4997C21.1755 18.5497 20.5755 16.3397 18.7855 16.3397C16.9955 16.3397 16.3955 18.5597 16.3955 20.4997C16.3955 22.4397 17.4655 23.3897 18.7855 23.3897C20.1055 23.3897 21.1755 22.4497 21.1755 20.4997Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMealLight);
export default __webpack_public_path__ + "static/media/icon_meal_light.e40da956.svg";
export { ForwardRef as ReactComponent };